import React, { useEffect, useState } from 'react';

import { generateIdFromHeadingContent, } from 'utils/helper';

interface Props {
  id: string;
  slug: string;
  onClose?: () => void;
}

export type ScrollSpyItem = {
  label: string;
  id: string;
  level: number;
};

const HEADER_HEIGHT = 74;

export const PostScrollSpy: React.FC<Props> = ({ id, slug, onClose }) => {
  const [activeItem, setActiveItem] = useState('');
  const [items, setItems] = useState<ScrollSpyItem[]>([]);
  const scrollListener = () => {
    const content = document
      .querySelector(id)
      ?.querySelectorAll('h2,h3') as NodeListOf<HTMLHeadingElement>;
    const docElem = document.documentElement;
    const docBody = document.body;
    const scrollTop =
      docElem.scrollTop + HEADER_HEIGHT || docBody.scrollTop + HEADER_HEIGHT;

    content?.forEach((item, index) => {
      if (index >= 0 && index < content.length - 1) {
        const currentOffset = item.offsetTop;
        const nextOffset = content[index + 1].offsetTop;
        if (
          items[index] &&
          currentOffset <= scrollTop &&
          scrollTop <= nextOffset
        ) {
          setActiveItem(items[index].id);
        } else if (scrollTop > nextOffset && items[index + 1]) {
          setActiveItem(items[index + 1].id);
        }
      }
    });
  };

  const handleScrollToSection = itemId => {
    setActiveItem(itemId);
    const targetEl = document.querySelector(`#${itemId}`) as HTMLElement;
    const scrollPosition = targetEl.offsetTop - HEADER_HEIGHT;
    window.scrollTo(0, scrollPosition);
  };

  useEffect(() => {
    if (items.length > 0) {
      setActiveItem(items[0].id);
      document.addEventListener('scroll', scrollListener, { passive: true });
    }
    return () => document.removeEventListener('scroll', scrollListener);
  }, [items, id]);

  useEffect(() => {
    const content = document.querySelector(id)?.querySelectorAll('h2,h3');
    if (content) {
      const menuList: ScrollSpyItem[] = [];
      content.forEach(item => {
        item.id = generateIdFromHeadingContent(item.textContent);
        const scrollItem: ScrollSpyItem = {
          label: item.textContent,
          id: item.id,
          level: 1
        };
        if (item.tagName === 'H3') {
          scrollItem.level = 2;
        }
        menuList.push(scrollItem);
      });
      setItems(menuList);
    }
  }, [slug]);

  return (
    items.length > 0 && (
      <div id="scroll-spy-nav">
        <div className="mb-4">
          <div className="flex justify-between p-4 md:p-0">
            <h1 className="text-base font-medium">Mục lục</h1>
            <button className="block md:hidden" onClick={onClose}>
              <img
                src={'/svg/icon-close-2.svg'}
                alt="menu"
                width={20}
                height={20}
              />
            </button>
          </div>
          <div className="block md:hidden w-full h-[1px] bg-gray-950" />
        </div>

        <div className="overflow-auto mb-4 max-h-[350px] md:max-h-none">
          {items.map(item => (
            <div
              key={item.id}
              className={`flex ${item.level === 1 ? 'pl-0' : 'pl-3'}`}
            >
              {item.id === activeItem && (
                <div
                  className="min-w-[3px] bg-brand-300"
                  style={{
                    borderRadius: '0px 100px 100px 0px'
                  }}
                />
              )}
              <button
                className={`text-sm p-1.5 text-left ${
                  item.id === activeItem
                    ? 'font-medium text-brand-300'
                    : 'font-normal text-gray-300'
                }`}
                onClick={() => handleScrollToSection(item.id)}
              >
                {item.label}
              </button>
            </div>
          ))}
        </div>
      </div>
    )
  );
};
